var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolygon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 181,
    height: 181,
    viewBox: "0 0 181 181",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Polygon",
    transform: "translate(0.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1091",
    "data-name": "Rectangle 1091",
    width: 181,
    height: 181,
    transform: "translate(-0.12)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M133.3,57.59a9.8,9.8,0,0,0-9.786,0l-22.45,13.374L85.807,79.686,63.357,93.06a9.8,9.8,0,0,1-9.786,0L35.727,82.594a10.044,10.044,0,0,1-4.893-8.432V53.52a9.442,9.442,0,0,1,4.893-8.431L53.284,34.913a9.8,9.8,0,0,1,9.786,0L80.627,45.089a10.044,10.044,0,0,1,4.893,8.431V66.894l15.254-9.013V44.507a9.442,9.442,0,0,0-4.893-8.431L63.357,16.887a9.8,9.8,0,0,0-9.786,0l-33.1,19.189a9.442,9.442,0,0,0-4.893,8.431V83.175a9.442,9.442,0,0,0,4.893,8.431l33.1,19.189a9.8,9.8,0,0,0,9.786,0l22.45-13.083L101.062,88.7l22.45-13.083a9.8,9.8,0,0,1,9.786,0l17.557,10.176a10.044,10.044,0,0,1,4.893,8.431v20.642a9.442,9.442,0,0,1-4.893,8.431L133.3,133.763a9.8,9.8,0,0,1-9.786,0l-17.557-10.176a10.044,10.044,0,0,1-4.893-8.432V101.782l-15.254,9.013v13.374A9.442,9.442,0,0,0,90.7,132.6l33.1,19.189a9.8,9.8,0,0,0,9.786,0l33.1-19.189a10.044,10.044,0,0,0,4.893-8.431V85.5a9.443,9.443,0,0,0-4.893-8.431Z",
    transform: "translate(-3.579 6.421)",
    fill: "#7b3fe4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/Polygon.fabfddc90c6bd1b96e68ba73b5fc3c9e.svg";
export { ForwardRef as ReactComponent };